import React from 'react';
import PropTypes from 'prop-types';

export const ParagraphWrapper = Component => {
  return props => {
    const { data, type, id } = props;
    const paragraphType = data?.type || type;
    const paragraphId = data?.id || id;

    if (paragraphType && paragraphId) {
      return (
        <div
          className={`module--type-${paragraphType} module--id-${paragraphId}`}
        >
          <Component {...props} />
        </div>
      );
    }
    return <Component {...props} />;
  };
};

ParagraphWrapper.propTypes = {
  Component: PropTypes.element
};
